module.exports = __webpack_public_path__ + "static/media/show-more-arrow.d5e759fe.svg";